


















































import * as analyticHelper from '@/lib/analytic-helper';
import { Component, Prop, Vue, Provide, Inject, Watch, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import EntityResultsPanel from '../_entity-results-panel/entity-results-panel.vue';
import MenuResultsPanel from '../_menu-results-panel/menu-results-panel.vue';

const searchStore = namespace('SearchState');

interface IEntityResult {
  entityType: string;
  name: string;
  code: string;
  entityUrl: string;
}

@Component({
  name: 'MainResultsPanel',
  components: {
    EntityResultsPanel,
    MenuResultsPanel,
  },
})
export default class MainResultsPanel extends Vue {
  data(){
    return {
      activeButtonId: "btnEntity",
      entitySelected: true,
      menuSelected: false,
    };
  }

  mounted(){
  }

  updated(){
  }

  @Inject('searchText') public searchTextInjector: () => string;
  public get searchText() {
    return this.searchTextInjector();
  }
  
  public get panelToDisplay(): string {
    const searchMode: boolean = (this.searchText?.length >= 3);

    if(this.$data.entitySelected) {
      if (searchMode) {
        return 'searching-entities'
      }else{
        return 'recent-entities'
      }
    }
    if(this.$data.menuSelected){
      if(searchMode){
        return 'searching-menu';
      }
    }else{
        return 'recent-menu'
    }
    return 'recent-menu';
  }

  private setSelectedToggle(buttonId:string):void {
    if(buttonId==="btnEntity"){
      this.$data.entitySelected=true;
      this.$data.menuSelected=false;
    }
    if(buttonId==="btnMenu"){
      this.$data.entitySelected=false;
      this.$data.menuSelected=true;
    }
  }
  
  private onClick(event: PointerEvent): void {
    if(event.target){
      const target = event.target as HTMLButtonElement;
      this.$data.activeButtonId = target.id;
      this.setSelectedToggle(target.id);
      this.buildToggleButtons();
    }
  }

  private onKeyDown(event: KeyboardEvent): void {
    if(event.target){
      const target = event.target as HTMLButtonElement;
      
      if(event.code === "Space" || event.code === "Spacebar" || event.code === "Enter"){ // older browsers may return "Spacebar"
        this.$data.activeButtonId = target.id;
        this.setSelectedToggle(target.id);
        this.buildToggleButtons();
      }
    }
  }

  private buildToggleButtons(){
    const toggleButtons = document.querySelector("[class^='ax-toggle-buttons']");
    if (!toggleButtons) {
      return;
    }
  }

  @Emit('navigate') public navigate(e: Event) { return e; }
}
